import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import InputField from "common/customInputField";
import Button from "react-bootstrap/Button";
import { sendEmail, pdfBlob, emailNotification, fromEmailVal } from "store/priceQuote/actionCreator";
import { downloadPdf } from "utils/common";
import warning from "svg/warning.svg";
import { api } from "store/slices/api";
import { toast } from "react-toastify";
import "./style.scss";

const DeliverQuote = ({ territoryAccess }) => {
  const dispatch = useDispatch();
  const { quoteId } = useParams();
  const [emailValid, setEmailValid] = useState("");
  const [ccValid, setCcValid] = useState("");
  const [subValid, setSubValid] = useState("");
  const { sub: userId, hasUpdateAccess } = useSelector((state) => state.loggedInUser);
  const [notification, setNotification] = useState("");
  const [fromEmail, setFromEmail] = useState("");
  const [toEmail, setToEmail] = useState("");
  const [carbonCopy, setCarbonCopy] = useState("");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [emailSent, setEmailSent] = useState(true);

  const { data: employee } = api.useGetEmployeeQuery(userId);
  const { data: quoteFields = {} } = api.useGetPriceQuoteQuery(quoteId);
  const { storeNumber } = quoteFields;

  useEffect(() => {
    if (userId && storeNumber && employee) {
      dispatch(fromEmailVal({ employee, storeNumber }))
        .then((res) => {
          if (res) {
            setBody(
              `Respectfully,\n${res?.name}\n${res?.jobTitle ? res?.jobTitle + "\n" : ""}The Sherwin-Williams Company`,
            );
            setFromEmail(res?.fromEmail);
            setCarbonCopy(res?.fromEmail);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    }
  }, [userId, storeNumber, employee]);

  useEffect(() => {
    if (quoteId && emailSent) {
      dispatch(emailNotification(quoteId))
        .then((res) => {
          if (res.status === "0" || res.status === "1") {
            const [description, dateTimeString] = res.statusDesc?.split("on ") || [];
            const [datePart, timePart] = dateTimeString?.split(" ") || [];
            let updatedDateTime = "";

            if (datePart && timePart) {
              const dateTimeStamp = `${datePart}T${timePart?.slice(0, -1)}Z`;
              const date = new Date(dateTimeStamp).toLocaleDateString();
              const time = new Date(dateTimeStamp).toLocaleTimeString();
              updatedDateTime = `${description} on ${date} at ${time}.`;
            } else {
              updatedDateTime = res.statusDesc;
            }

            setNotification(updatedDateTime);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    }
    setEmailSent(false);
  }, [quoteId, emailSent]);

  const handlePDfEmail = (type) => {
    if (type === "pdf") {
      openPdf();
    } else if (type === "email") {
      handleSendEmail();
    }
  };

  const openPdf = () => {
    dispatch(pdfBlob(quoteId))
      .then((res) => {
        res.status === "0" ? downloadPdf(res.pdfData, `Quote_${quoteId}`) : toast.error(res.statusDesc);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const emailValidation = (email, carbonCopy, subject, body) => {
    let valid = true;
    setEmailValid("");
    setCcValid("");
    setSubValid("");
    if (!email || email == "") {
      valid = false;
      setEmailValid("Please enter an Email");
    } else if (email.length > 254) {
      valid = false;
      setEmailValid("Please enter upto 254 characters");
    } else if (!subject || subject == "") {
      valid = false;
      setSubValid("Enter a Subject");
    }
    return valid;
  };

  const handleSendEmail = (e) => {
    if (!emailValidation(toEmail, carbonCopy, subject, body)) {
      return;
    }

    toast
      .promise(dispatch(sendEmail({ fromEmail, body, toEmail, carbonCopy, subject, quoteId, userId, storeNumber })), {
        pending: "Sending email",
        success: { render: ({ data }) => data.statusDesc },
        error: "Error while sending email",
      })
      .then((res) => {
        if (res.status === "0") {
          setEmailSent(true);
        }
      });
  };

  return (
    <>
      {notification && (
        <div className="alert d-flex align-items-center email-alert" role="alert">
          <img src={warning} alt={"warning-icon"} />
          <div>{notification}</div>
        </div>
      )}
      <div className="pdfOptions cover-page">
        <div className="pdfOptions cover-page--title">Email Quote</div>
        <div className="row">
          <div className="col-12 col-sm-12 col-md-6 col-lg-8 search-form-container__fields__form-group">
            <InputField
              type="text"
              label="From"
              id="fromEmail"
              fieldClasses="form-control search-form-container__fields__form-group__item"
              value={fromEmail}
              disabled={true}
              isRequired={false}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-12 col-md-6 col-lg-8 search-form-container__fields__form-group">
            <InputField
              type="text"
              label="To"
              id="toEmail"
              fieldClasses="form-control search-form-container__fields__form-group__item"
              value={toEmail}
              onChange={(e) => {
                setToEmail(e.target.value);
              }}
              isRequired={false}
              errorMsg={emailValid}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-12 col-md-6 col-lg-8 search-form-container__fields__form-group">
            <InputField
              type="text"
              label="CC"
              id="carbonCopy"
              fieldClasses="form-control search-form-container__fields__form-group__item"
              value={carbonCopy}
              onChange={(e) => {
                setCarbonCopy(e.target.value);
              }}
              isRequired={false}
              errorMsg={ccValid}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-12 col-md-6 col-lg-8 search-form-container__fields__form-group">
            <InputField
              type="text"
              label="Subject"
              id="subject"
              fieldClasses="form-control search-form-container__fields__form-group__item"
              value={subject}
              onChange={(e) => {
                setSubject(e.target.value);
              }}
              isRequired={false}
              errorMsg={subValid}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-8 search-form-container__fields__form-group">
            <div className="form-group">
              <label htmlFor="LaborCodeDescription" className="laborCode-Modal__fields__form-group__label">
                <span className="laborCode-Modal__fields__form-group__label--text">Message</span>
              </label>
              <textarea
                className="form-control search-form-container__fields__form-group__item text-area-large"
                id="body"
                value={body}
                onChange={(e) => {
                  setBody(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
        <Button variant="outline-primary" onClick={() => handlePDfEmail("pdf")}>
          View PDF
        </Button>
        {(territoryAccess || hasUpdateAccess) && (
          <Button variant="outline-primary" onClick={() => handlePDfEmail("email")}>
            Email Quote
          </Button>
        )}
      </div>
    </>
  );
};

export default DeliverQuote;
